import LogsPanel from './LogsPanel';

export default LogsPanel;
